import SharesChart from "components/charts/modern/SharesChart";
import TradesChart from "components/charts/modern/TradesChart";
import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import { CompanyLiquidityTabEnum } from "components/company/v3/menu/enums";
import { Tabs } from "components/ui/Tabs";
import { AreaChartIcon, BarChart3Icon } from "lucide-react";
import { useIntl } from "react-intl";

interface FiisLiquityBoxProps {
  tickerSymbol: string;
  tab: CompanyLiquidityTabEnum;
  onChangeTab: (tab: CompanyLiquidityTabEnum) => void;
}

export default function FiisLiquityBox({ tickerSymbol, tab, onChangeTab }: FiisLiquityBoxProps) {
  const intl = useIntl();

  return (
    <CompanyContainer>
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyLiquidityTabEnum.TRADE_HISTORY}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyLiquidityTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            activeTab={tab}
            tabs={[
              {
                value: CompanyLiquidityTabEnum.TRADE_HISTORY,
                label: intl.formatMessage({
                  defaultMessage: "Negócios",
                  description: "Aba do menu superior da empresa",
                  id: "aU3x7h",
                }),
                icon: <BarChart3Icon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyLiquidityTabEnum.SHARES_OUTSTANDING,
                label: intl.formatMessage({
                  defaultMessage: "Cotas Emitidas",
                  description: "Aba do menu superior da empresa",
                  id: "eOl0Yb",
                }),
                icon: <AreaChartIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={CompanyLiquidityTabEnum.TRADE_HISTORY}>
            <TradesChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyLiquidityTabEnum.SHARES_OUTSTANDING}>
            <SharesChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
